// extracted by mini-css-extract-plugin
export var container = "_ve-0";
export var table = "_ve-2";
export var tableWrapper = "_ve-1";